import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerI18n, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MASKS } from 'ng-brazil';
import { Assignor } from 'src/app/models/assignor';
import { Auth } from 'src/app/models/auth';
import { AllocatedBalance } from 'src/app/models/balance';
import { GerarBoletoCadastro } from 'src/app/models/gerar-boleto-cadastro';
import { IntencaoDepositoDetalhes } from 'src/app/models/intencao-deposito-detalhes';
import { DepositoViaBoletoRequestModel, DepositoViaPIXRequestModel } from 'src/app/models/request/deposito-via-boleto-request-model';
import { GenerateDepositRequest } from 'src/app/models/request/depositos-request';
import { GerarPixDinamico } from 'src/app/models/request/gerar-pix-dinamico';
import { BRCodePix } from 'src/app/models/response/brcode-pix';
import { PixInfo } from 'src/app/models/response/deposit-response';
import { QRCodePixDinamico } from 'src/app/models/response/pix-qrcode';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BalanceService } from 'src/app/services/balance.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { DepositoService } from 'src/app/services/deposito.service';
import { DepositosPagamentosService } from 'src/app/services/depositos-pagamentos.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { TipoDepositoEnum } from 'src/app/shared/enums/tipo-deposito-enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { CustomDatepickerI18n } from 'src/app/shared/helpers/locale/CustomDatepickerI18n';
import { I18n } from 'src/app/shared/helpers/locale/I18n';
import { NgbDateCustomParserFormatter } from 'src/app/shared/helpers/locale/NgbDateCustomParserFormatter';
import { environment } from 'src/environments/environment';
import { VisualizarBoletoService } from '../../../visualizar-boleto/visualizar-boleto.service';

@Component({
  selector: 'app-depositos-create',
  templateUrl: './depositos-create.component.html',
  styleUrls: ['./depositos-create.component.css'],
  providers: [
      I18n,
      { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
      { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class DepositosCreateComponent implements OnInit {

    public currentUser: Auth;
    public message = '';
    public MASKS = MASKS;
    public sortOrder: boolean;
    public intencaoDepositoDetalhes: IntencaoDepositoDetalhes = null;
    public depositoPixRequest: GerarPixDinamico;
    public assignorInfo: Assignor;
    public qrCodePix: PixInfo;
    public brCodePix: BRCodePix;
    public valorQRCode: number;
    public nomeEmpresa: string;
    private temEndereco: boolean = false;
    public temInscricaoMunicipal: boolean = false;
    private temDadoBancario: boolean = false;
    public dataAtual: any;
    public isDisabled = false;
    public allocatedBalances: AllocatedBalance[];

    @ViewChild('modalAvisoInscricaoMunicipal', { static: true })
    modalAvisoInscricaoMunicipal: TemplateRef<any>;

    constructor(
        private authenticationService: AuthenticationService,
        private cedenteService: CedenteService,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private depositoService: DepositoService,
        private transactionservice: TransactionService,
        private visualizarBoletoService: VisualizarBoletoService,
        private parametrosDataService: ParametrosDataService,
        private depositsPaymentsService: DepositosPagamentosService,
        private balanceService: BalanceService,
        private configDatepicker: NgbDatepickerConfig,
        private calendar: NgbCalendar,
        private router: Router
    ) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.loadCalendar();
        this.qrCodePix = new PixInfo();
        this.loadInfo();

        this.message = '';
        this.carregarSaldos();
    }

    carregarSaldos() {
        this.balanceService.getAllocatedBalances(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.allocatedBalances = response.result;
                }
                else {
                    this.alertService.error(response.message);
                }
            }, error => { console.log(error.message) }
        );
    }

    private loadCalendar() {
        const currentDate = new Date();
        const feriadosModel: NgbDate[] = [];
        this.configDatepicker.firstDayOfWeek = 0;
        this.dataAtual = currentDate.getDate()<10 ? '0'+currentDate.getDate()+'/' : currentDate.getDate()+'/';
        this.dataAtual = this.dataAtual + ((currentDate.getMonth()+1)<10 ? '0'+(currentDate.getMonth()+1)+'/' : (currentDate.getMonth()+1)+'/');
        this.dataAtual = this.dataAtual + (currentDate.getFullYear());

        this.configDatepicker.markDisabled = (date: NgbDate) => {
            const holiday = feriadosModel.find(x => x.day === date.day && x.month === date.month && x.year === date.year);

            if (holiday) {
                return this.calendar.getWeekday(date) === 6 || this.calendar.getWeekday(date) === 7 || holiday.equals(date);
            }

            return this.calendar.getWeekday(date) === 6 || this.calendar.getWeekday(date) === 7;
        };

        this.configDatepicker.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    }

    private loadInfo() {
        if(JSON.parse(localStorage.getItem('assignorInfo')) == null || JSON.parse(localStorage.getItem('assignorInfo')) == undefined)   {
            this.cedenteService.getAssignorInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    this.assignorInfo = response.result;
                    localStorage.setItem('assignorInfo', JSON.stringify(response.result));

                    const tam = environment.TOTAL_CARACTERE_CNPJ - this.assignorInfo.document.toString().length;

                    let str = this.assignorInfo.document.toString();

                    for (let i = 0; i < tam; i++) { str = '0' + str; }
                        this.assignorInfo.document = str;
                }, error => {
                    this.alertService.error('Ocorreu um erro ao consultar as informações da empresa. Tente novamente mais tarde');
                }
            );
        }
        else{
            this.assignorInfo = JSON.parse(localStorage.getItem('assignorInfo'));
            const tam = environment.TOTAL_CARACTERE_CNPJ - this.assignorInfo.document.toString().length;

            let str = this.assignorInfo.document.toString();

            for (let i = 0; i < tam; i++) { str = '0' + str; }
                this.assignorInfo.document = str;
        }

        const parametros = this.parametrosDataService.currentParametrosValue;
        if (parametros) {
            if (parametros[ParametrosKey.temEndereco]) {
                this.temEndereco = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.temEndereco]
                );
            }

            if (parametros[ParametrosKey.temInscricaoMunicipal]) {
                this.temInscricaoMunicipal = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.temInscricaoMunicipal]
                );
            }

            if (parametros[ParametrosKey.temDadoBancario]) {
                this.temDadoBancario = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.temDadoBancario]
                );
            }
        }

        if(!this.temInscricaoMunicipal){
            this.modalService.open(this.modalAvisoInscricaoMunicipal,{ centered: true, size: 'lg', backdrop: 'static' })
        }
    }

    depositarViaPix(content, valor, dtVencimento: any, allocatedBalanceId: number) {

        dtVencimento = dtVencimento.split('/')
        dtVencimento = new Date(dtVencimento[2],dtVencimento[1]-1,dtVencimento[0]);

        let formValid = true;

        
        valor = valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
        if (!valor || +valor == 0) {
          this.message = 'Preencha o valor';
          formValid = false;
        }

        if(formValid){
          this.modalService.open(content, { centered: true, size: 'xl' });

            const generateDepositRequest = new GenerateDepositRequest();
            generateDepositRequest.accountGuid = this.currentUser.token.accountId;
            generateDepositRequest.value = +valor;
            generateDepositRequest.dueDate = dtVencimento;
            generateDepositRequest.allocatedBalanceId = +allocatedBalanceId;
            generateDepositRequest.depositType = TipoDepositoEnum.PIX;            

            this.depositoService.generateDeposit(
                this.currentUser.token.assignorGuid,
                this.currentUser.token.userReferenceId, 
                generateDepositRequest
            ).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {              
                    
                        this.valorQRCode = +valor;
                        this.qrCodePix = response.result?.pixInfo;

                    } else {
                    this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                }
            );
        }
        else{
            this.alertService.error(this.message)
        }
    }

    // gerarQRCodePIX(depositoPixRequest: GerarPixDinamico){
    //     this.transactionservice.GerarPixDinamico(depositoPixRequest).subscribe(
    //         response => {
    //         if (response.status === ApiError.Sucesso) {
    //             /* console.log(response) */


    //             //this.qrCodePix = response.result;

    //             /* console.log(this.qrCodePix) */
    //         } else {
    //             this.alertService.error(response.message);
    //         }
    //         }, error => {
    //         this.alertService.error('Ocorreu um erro ao visualizar intenção de depósito');
    //         }
    //     );
    // }

    depositarViaBoleto(valor: string, dtVencimento: any, allocatedBalanceId: number) {
        valor = valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
        let formValid = true;
        dtVencimento = dtVencimento.split('/')
        dtVencimento = new Date(dtVencimento[2],dtVencimento[1]-1,dtVencimento[0]);

        if (!valor || +valor == 0) {
            this.message = 'Preencha o valor';
            formValid = false;
        }

        /*if(!this.temDadoBancario) {
            this.alertService.error("Para gerar depósitos com boleto é necessário ter uma conta bancária cadastrada! Para cadastrar navegue até Administrativo > Dados bancários");
            this.message = 'Dado bancário não encontrado!';
            formValid = false;
        }

        if(!this.temEndereco) {
            this.alertService.error("Para gerar depósitos com boleto é necessário ter um endereço cadastrado! para cadastrar navegue até Administrativo > Dados da empresa");
            this.message = 'Você ainda não cadastrou um endereço!';
            formValid = false;
        }*/

        if (formValid) {

            const generateDepositRequest = new GenerateDepositRequest();
            generateDepositRequest.accountGuid = this.currentUser.token.accountId;
            generateDepositRequest.value = +valor;
            generateDepositRequest.dueDate = dtVencimento;
            generateDepositRequest.allocatedBalanceId = +allocatedBalanceId;
            generateDepositRequest.depositType = TipoDepositoEnum.Boleto;            

            this.depositoService.generateDeposit(
                this.currentUser.token.assignorGuid,
                this.currentUser.token.userReferenceId, 
                generateDepositRequest
            ).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {              
                    
                        this.visualizarBoletoService.arquivoBase64 = response.result.boletoInfo.pdf;

                        const options = { keepAfterRouteChange : true };

                        this.alertService.notificationInfo(
                            'Intenção de depósito', 
                            'Registrada com sucesso, assim que o pagamento do boleto for identificado vamos creditar o valor na conta da cedente. Obrigado!',
                            options
                        );

                        this.router.navigate(['portal/boleto']);

                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                }
            );         
        }
    }

    private GerarBoleto(intencaoDepositoGuid: string, valor: number, dtVencimento: Date) {

        this.depositoService.generateBoleto(intencaoDepositoGuid, new GerarBoletoCadastro(valor, dtVencimento), this.currentUser.token.assignorGuid).subscribe(
            response => {
            if (response.status === ApiError.Sucesso) {
                this.visualizarBoletoService.arquivoBase64 = response.result.pdf;

                const options = {
                keepAfterRouteChange : true
                };

                this.alertService.notificationInfo('Intenção de depósito', 'Registrada com sucesso, assim que o pagamento do boleto for identificado vamos creditar o valor na conta da cedente. Obrigado!', options);

                this.router.navigate(['portal/boleto']);
            } else {
                this.alertService.error(response.message);
            }
            }, error => {
            this.alertService.error('Ocorreu um erro ao gerar boleto');
            }
        );
    }

    buscarPagamentos(){
        this.depositsPaymentsService.sendClickEvent();
    }

    navigateToDadosEmpresa(){
        this.router.navigate(['portal/dadoempresa/detail']);
    }

}
